<div class="empty-line--wrapper">
    <span class="empty-line animated-background"
          [class.bigger-first]="biggerFirstLine"
          *ngFor="let number of [].constructor(nbLines)"></span>
</div>
